// Generated by `npm run reeffish` (scripts/reefFish.ts): the balance the taape's stocks open at,
// NOAA's divers' count of it at Maui Nui (./reefSurveys.ts) and its fishing (Nadon 2017), its larvae settling as
// Wren et al.'s model sends them (./exchange.ts, from data/bcodmo-665467/). Do not edit by hand.
// tests/maniniTaape.test.ts holds the balance to a year's step.
import type { FishJanuary, FishSupply } from '../../fish';
import { REEF_FISH_EXCHANGE } from './exchange';

/** The exchange, and the balance's larvae a kilogram of spawners sends, fishing and the rest's spawners. */
export const TAAPE_SUPPLY: FishSupply = {
  exchange: REEF_FISH_EXCHANGE,
  larvaePerKgDay: 13.7813,
  fishingPerYear: 0.21,
  restSpawnersKg: 1461740,
};

/** The balance's first of January (expected values; a world opening rounds the fish): each island's fish by month of age since settling, and the larvae afloat by their days to settle from that day. */
export const TAAPE_JANUARY: FishJanuary = {
  islands: [
    [318868, 227677, 134067, 129227, 115381, 0, 0, 0, 0, 0, 0, 0, 78150.5, 92252.2, 90755.5, 87467.9, 78078.6, 0, 0, 0, 0, 0, 0, 0, 51790.5, 60621, 59028.7, 56218.9, 49526.5, 0, 0, 0, 0, 0, 0, 0, 29455.2, 34176.4, 33046.3, 31303.9, 27466.5, 0, 0, 0, 0, 0, 0, 0, 16178.3, 18767.5, 18144.3, 17185.7, 15077.8, 0, 0, 0, 0, 0, 0, 0, 8879.15, 10300.1, 9958.02, 9431.89, 8274.97, 0, 0, 0, 0, 0, 0, 0, 4873, 5652.85, 5465.09, 5176.34, 4541.41, 0, 0, 0, 0, 0, 0, 0, 2674.36, 3102.35, 2999.31, 2840.84, 2492.38, 0, 0, 0, 0, 0, 0, 0, 17162],
    [321843, 296880, 189223, 178302, 155104, 0, 0, 0, 0, 0, 0, 0, 103367, 130054, 128093, 120685, 104960, 0, 0, 0, 0, 0, 0, 0, 68501.9, 85461.5, 83313.5, 77568.5, 66577.5, 0, 0, 0, 0, 0, 0, 0, 38959.6, 48180.8, 46641.8, 43191.8, 36922.6, 0, 0, 0, 0, 0, 0, 0, 21398.6, 26457.9, 25609, 23712.1, 20268.7, 0, 0, 0, 0, 0, 0, 0, 11744.2, 14520.8, 14054.8, 13013.7, 11123.9, 0, 0, 0, 0, 0, 0, 0, 6445.38, 7969.21, 7713.47, 7142.11, 6104.93, 0, 0, 0, 0, 0, 0, 0, 3537.3, 4373.6, 4233.24, 3919.67, 3350.46, 0, 0, 0, 0, 0, 0, 0, 23614.9],
    [179749, 116651, 66387.9, 63188.1, 61438, 0, 0, 0, 0, 0, 0, 0, 39240.6, 45738.9, 44940.7, 42769.1, 41575.3, 0, 0, 0, 0, 0, 0, 0, 26004.9, 30056.1, 29230.1, 27489.3, 26371.9, 0, 0, 0, 0, 0, 0, 0, 14789.9, 16944.7, 16364, 15306.6, 14625.4, 0, 0, 0, 0, 0, 0, 0, 8123.38, 9305, 8984.76, 8403.28, 8028.61, 0, 0, 0, 0, 0, 0, 0, 4458.36, 5106.84, 4931.06, 4611.9, 4406.26, 0, 0, 0, 0, 0, 0, 0, 2446.81, 2802.7, 2706.23, 2531.07, 2418.21, 0, 0, 0, 0, 0, 0, 0, 1342.84, 1538.16, 1485.21, 1389.08, 1327.14, 0, 0, 0, 0, 0, 0, 0, 8614.85],
    [28292.3, 16323.7, 8823.45, 8472.48, 8145.19, 0, 0, 0, 0, 0, 0, 0, 5181.89, 6043.88, 5972.96, 5734.63, 5511.89, 0, 0, 0, 0, 0, 0, 0, 3434.05, 3971.57, 3884.9, 3685.86, 3496.28, 0, 0, 0, 0, 0, 0, 0, 1953.07, 2239.06, 2174.9, 2052.37, 1938.97, 0, 0, 0, 0, 0, 0, 0, 1072.73, 1229.55, 1194.14, 1126.74, 1064.4, 0, 0, 0, 0, 0, 0, 0, 588.746, 674.811, 655.375, 618.38, 584.164, 0, 0, 0, 0, 0, 0, 0, 323.112, 370.345, 359.678, 339.375, 320.597, 0, 0, 0, 0, 0, 0, 0, 177.327, 203.25, 197.396, 186.253, 175.947, 0, 0, 0, 0, 0, 0, 0, 1143.6],
  ],
  afloat: [
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
  ],
};
